import React from "react";
import { ClockLoader } from "react-spinners";
import Cookies from "universal-cookie";
import { brandColors } from "../brandedComponent/BrandedColors";
import { LifeSafer } from "../../_helpers/BrandConstants";

export const TimeLoader = () => {
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;

  return <ClockLoader color={brandColors[brand].primary} size={50} />;
};
